<template>
  <div>
    <div class="flex justify-center">
      <div class="m-auto flex w-20 items-center">
        <div class="loading-bounce loading-bounce__1" />
        <div class="loading-bounce loading-bounce__2" />
        <div class="loading-bounce" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @keyframes animation__three-bounce {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }

  .loading-bounce {
    width: 20px;
    height: 20px;
    background-color: #004280;
    border-radius: 100%;
    margin-right: 5px;
    animation: animation__three-bounce 1.4s ease-in-out 0s infinite both;
  }

  .loading-bounce__1 {
    animation-delay: -0.32s;
  }

  .loading-bounce__2 {
    animation-delay: -0.16s;
  }
</style>
